module.exports = __webpack_public_path__ + "img/ZaffaJiraffa.9fdb2703.jpg";